import React from "react"
import { HeadFC, withPrefix, PageProps } from "gatsby"

interface HeadUniversalProps {
  metaTitle?: string
  metaDescription?: string
  ogImage?: string
  disableOgTags?: boolean
  contentType?:string
}

export const HeadUniversal: HeadFC<HeadUniversalProps> = ({
  metaTitle,
  metaDescription,
  disableOgTags = false,
  location,
  contentType="article"
}: HeadUniversalProps & PageProps) => {
  const isEvbqaMode = process.env.GATSBY_BASE_HOST_NAME?.includes("evbqa")
  const siteUrl = process.env.GATSBY_SITE_URL || ""
  const canonicalUrl = location?.pathname || ""


  const ogImage =
    "https://cdn.evbstatic.com/s3-build/prod/1929935-rc2025-04-22_20.04-py27-3eeb171/django/images/logos/eb_orange_on_white_1200x630.png"

  return (
    <>
      {!disableOgTags && (
        <>
          {metaTitle ? ( <meta property="og:title" content={metaTitle} />):null}
          <meta property="og:type" content={contentType} />
          <meta property="og:url" content={`${siteUrl}${canonicalUrl}`} />
          {ogImage ? <meta property="og:image" content={ogImage} />:null}
          {metaDescription ? <meta property="og:description" content={metaDescription} />:null}
        </>
      )}
      {isEvbqaMode ? (
        <>
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/blue-favicon-32x32.png")}
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/blue-favicon-32x32.png")}
            sizes="16x16"
          />
          <link
            rel="shortcut icon"
            href={withPrefix("/images/blue-favicon-32x32.png")}
          />
        </>
      ) : (
        <>
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/favicon-32x32.png")}
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/favicon-194x194.png")}
            sizes="194x194"
          />
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/favicon-96x96.png")}
            sizes="96x96"
          />
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/android-chrome-192x192.png")}
            sizes="192x192"
          />
          <link
            rel="icon"
            type="image/png"
            href={withPrefix("/images/favicon-16x16.png")}
            sizes="16x16"
          />
          <link rel="shortcut icon" href={withPrefix("/images/favicon.ico")} />
        </>
      )}
    </>
  )
}